export default "__VITE_ASSET__D1NjoZ5W__"